var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"intro-xs"},[_c('div',{staticClass:"col-50 flex column nowrap justify-center align-center animated fadeInLeft"},[_c('div',{staticClass:"container-text"},[_c('h2',{staticClass:"title title-52"},[_vm._v(_vm._s(_vm.$t('enlaces.textos.actualidad')))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2238486","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/intros/actualidad.vue
// module id = null
// module chunks = 